export const step1Questions = [
  {
    id: 'employee_first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_initial',
    title: 'Middle initial',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Please select filing status:',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_filing_jointly',
        shortName: 'Married/civil union filing jointly',
      },
      {
        codeValue: 'married_filing_separately',
        shortName: 'Married/civil union filing separately',
      },
      {
        codeValue: 'married_withhold_higher_rate',
        shortName: 'Married, but withhold at higher single rate',
      },
    ],
  },
];

export const allowancesInitialQuestions = [
  {
    id: 'dependents',
    title: 'Enter the number of dependents you plan to claim on your tax return. If you file jointly, then only one of you should claim the dependents on your W-4VT.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Enter an additional amount, if any, you want withheld from each check.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
